<template>
  <div class="hl-overlay">
    <div class="hl-window">
      <div class="hl-header">
        <div class="hl-top">
          <div class="hl-logo">
            <img src="@/assets/logo-nikan.png" class="hl-logo-img" alt="Nikan Logo" />
          </div>

          <div class="hl-actions">
            <button v-if="modalIsMinimizable" class="hl-minimize-btn" @click="changeMinimize(true)">
              <icon :icon="'minus'" />
            </button>

            <button class="hl-close-btn" @click="removeAll()" v-if="getTotalPercent === 100">
              <icon icon="times" />
            </button>
          </div>
        </div>

        <div class="hl-hero">
          <h2 class="hl-title">{{ $t('hard-loading.hero-title') }}</h2>
          <p class="hl-description">{{ $t('hard-loading.hero-description') }}</p>
        </div>
      </div>
      <div class="hl-body">
        <HardLoadingItem v-for="item in all" :data="item" :key="item.id" />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  import HardLoadingItem from './hard-loading-item.vue'
  import { mapActions, mapGetters } from 'vuex'

  export default defineComponent({
    name: 'HardLoading',
    components: {
      HardLoadingItem,
    },
    computed: {
      ...mapGetters({
        all: 'hardLoading/all',
        modalIsMinimizable: 'hardLoading/modalIsMinimizable',
        getTotalPercent: 'hardLoading/getTotalPercent'
      })
    },
    methods: {
      ...mapActions({
        changeMinimize: 'hardLoading/changeMinimize',
        removeAll: 'hardLoading/removeAll'
      })
    }
  })
</script>
<style lang="less"></style>